import { useEffect, useState } from 'react';

/**
 * A tiny history-based router: the app has a handful of pages and no need
 * for a routing library. `navigate` pushes a new entry; the browser's back
 * button works because we listen for popstate.
 */
export function usePath(): string {
  // Track the query string too, so "?week=…" and "?quarter=…" changes re-render the page
  // (a state value that never changes would make React skip the render).
  const [loc, setLoc] = useState(window.location.pathname + window.location.search);
  useEffect(() => {
    const onPop = () => setLoc(window.location.pathname + window.location.search);
    window.addEventListener('popstate', onPop);
    window.addEventListener('openmd:navigate', onPop);
    return () => {
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('openmd:navigate', onPop);
    };
  }, []);
  return loc.split('?')[0];
}

export function navigate(path: string): void {
  window.history.pushState(null, '', path);
  window.dispatchEvent(new Event('openmd:navigate'));
}

/** Match "/admin/sites/:siteId/periods/:periodStart" style patterns; returns the params or null. */
export function match(pattern: string, path: string): Record<string, string> | null {
  const p = pattern.split('/');
  const a = path.replace(/\/+$/, '').split('/');
  if (p.length !== a.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < p.length; i++) {
    if (p[i].startsWith(':')) params[p[i].slice(1)] = decodeURIComponent(a[i]);
    else if (p[i] !== a[i]) return null;
  }
  return params;
}
